export default {
      id: "clock-usage",
      viewBox: "0 0 280 280",
      url: __webpack_public_path__ + "img/icons.svg#clock",
      toString: function () {
        return this.url;
      }
    }